"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterGiveawayButton = void 0;
const ButtonNew_1 = __importDefault(require("root/src/client/web/base/ButtonNew"));
const LoadingCircles_1 = __importDefault(require("root/src/client/v2/common/components/LoadingCircles"));
const useEnterGiveawayButton_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useEnterGiveawayButton");
const useUser_1 = require("root/src/client/v2/common/hooks/useUser");
const BaseTooltip_1 = require("root/src/client/v2/common/components/BaseTooltip/BaseTooltip");
const useCreatorGiveaways_1 = require("root/src/client/web/giveaway/hooks/useCreatorGiveaways");
const use_between_1 = require("use-between");
const useGiveawayTermsCheckbox_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawayTermsCheckbox");
const useGiveawaySection_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection");
const EnterGiveawayButtonTooltip = () => {
    const isAuthenticated = (0, useUser_1.useIsAuthenticated)();
    const giveaway = (0, useCreatorGiveaways_1.useCreatorActiveGiveaway)();
    if (!isAuthenticated) {
        return <BaseTooltip_1.BaseTooltipContent>To enter the giveaway, please log in.</BaseTooltip_1.BaseTooltipContent>;
    }
    if (!(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isSteamEntered)) {
        return <BaseTooltip_1.BaseTooltipContent>To enter the giveaway, please connect your Steam account.</BaseTooltip_1.BaseTooltipContent>;
    }
    return null;
};
const EnterGiveawayButton = () => {
    const { onEnterGiveaway, isLoading, classes, isSteamEntered } = (0, useEnterGiveawayButton_1.useEnterGiveawayButton)();
    const { isGiveawayTermsCheckboxSelected } = (0, use_between_1.useBetween)(useGiveawayTermsCheckbox_1.useGiveawayTermsCheckbox);
    const { isGiveawayTermsVisible } = (0, useGiveawaySection_1.useGiveawaySection)();
    return (<BaseTooltip_1.BaseTooltip tooltip={<EnterGiveawayButtonTooltip />}>
			<ButtonNew_1.default onClick={onEnterGiveaway} disabled={!isSteamEntered || (isGiveawayTermsVisible && !isGiveawayTermsCheckboxSelected)} className={classes.button}>
				{isLoading ? <LoadingCircles_1.default width={20} height={20}/> : (<span className={classes.buttonText}>Enter giveaway</span>)}
			</ButtonNew_1.default>
		</BaseTooltip_1.BaseTooltip>);
};
exports.EnterGiveawayButton = EnterGiveawayButton;
